module.exports = __webpack_public_path__ + "img/icon_fb.6a25eea8.svg";